import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards({
  category,
  demoLink,
  demoLabel = "Live demo",
  description,
  ghLink,
  image,
  previewLabel,
  headingLevel = "h2",
  stack = [],
  title,
}) {
  const hasActions = Boolean(ghLink || demoLink);
  const hasPairedActions = Boolean(ghLink && demoLink);

  return (
    <Card className="project-card-view">
      <div className="project-card-media">
        <Card.Img variant="top" src={image} alt={`${title}${previewLabel ? `: ${previewLabel}` : " preview"}`} className="project-card-image" loading="lazy" />
        {previewLabel && <span className="project-preview-label">{previewLabel}</span>}
      </div>
      <Card.Body className="project-card-body">
        <span className="project-category">{category}</span>
        <Card.Title as={headingLevel}>{title}</Card.Title>
        <Card.Text className="project-card-copy">
          {description}
        </Card.Text>
        <div className="project-chip-list">
          {stack.map((item) => (
            <span className="project-chip" key={item}>
              {item}
            </span>
          ))}
        </div>
        {hasActions && (
          <div className={`project-actions${hasPairedActions ? " project-actions-paired" : ""}`}>
            {ghLink && (
              <Button
                variant="primary"
                href={ghLink}
                target="_blank"
                rel="noreferrer"
                className="project-button"
              >
                <BsGithub aria-hidden="true" /> View source
              </Button>
            )}

            {demoLink && (
              <Button
                variant="primary"
                href={demoLink}
                target="_blank"
                rel="noreferrer"
                className={`project-button${ghLink ? " project-button-secondary" : ""}`}
              >
                <CgWebsite aria-hidden="true" /> {demoLabel}
              </Button>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
